import { Component } from '@angular/core';
import { AuthService } from 'src/app/core/modules/auth/services/auth.service';
import {versions} from '../../../environments/versions';
import {ParamMap, Params, Router, UrlTree} from '@angular/router';
import {Location} from '@angular/common';


@Component({
  selector: 'app-customer-login',
  templateUrl: './customer-login.component.html',
  styleUrls: ['./customer-login.component.scss']
})
export class CustomerLoginComponent {

  public versions: {
    version: string;
    revision: string;
    branch: string;
  } = versions;

  private redirectPath: string;
  private queryParams: Params;

  constructor(
    public authService: AuthService,
    private router: Router,
    private location: Location
  ) {
    this.redirectPath = this.getRedirectPath(router.url);
    this.queryParams = router.parseUrl(router.url).queryParams;
    // SYNC-1119: this cleans up the browser url so the user doesn't see '/sync/login/sync/jobs' or 'sync/login/sync/home?a=zzzzzzz' etc.
    location.go('/sync/login');
  }

  login(): void {
    this.authService.login('admin',null,null,this.redirectPath,this.queryParams)
      .catch(error => console.error(error));
  }

  openMore(): void {
    window.open('https://www.amplifiedit.com/little-sis-premium/', '_blank');
  }

  private getRedirectPath(fullPath: string) {
    const redirectPath = fullPath.split('/sync/login')[1];
    return redirectPath ? redirectPath.split('?')[0] : '/sync/home';
  }
}
